import React from 'react';
import StaticPage from '../../static/StaticPage';
import styles from '../../static/staticPage.module.css';

const RefundPolicyPage = () => {
  return (
    <StaticPage
      title="Refund &amp; Cancellation Policy"
      subtitle="Last updated: March 31, 2026. How cancellations, refunds, and disputes work on BarberShop."
    >
      <section className={styles.section}>
        <h2>Cancellations by you</h2>
        <p>
          If you cancel a prepaid booking before the salon&apos;s stated cutoff time (shown at
          checkout or in your confirmation), you are generally eligible for a full or partial refund
          per that salon&apos;s rules. Late cancellations may incur a fee retained by the partner or
          platform.
        </p>
      </section>
      <section className={styles.section}>
        <h2>Cancellations by the salon</h2>
        <p>
          If the salon cancels, we will work to reschedule you or refund the paid amount to your
          original payment method, typically within 5–10 business days depending on your bank or
          card issuer.
        </p>
      </section>
      <section className={styles.section}>
        <h2>No-shows</h2>
        <p>
          Missing an appointment without notice may be treated as fulfilled and non-refundable, in
          line with the partner&apos;s policy.
        </p>
      </section>
      <section className={styles.section}>
        <h2>Quality issues</h2>
        <p>
          If a service was not delivered as described, contact us within 48 hours of your
          appointment at <a href="mailto:support@timetofuture.com">support@timetofuture.com</a> with
          your booking ID. We may offer a partial refund, credit, or rebooking after review.
        </p>
      </section>
      <section className={styles.section}>
        <h2>Digital goods &amp; fees</h2>
        <p>
          Platform fees, convenience charges, or promotional credits may have different rules; those
          are disclosed before payment.
        </p>
      </section>
    </StaticPage>
  );
};

export default RefundPolicyPage;
